// Paths where the info banner is allowed to appear.
const INFO_BANNER_ALLOWED_PATHS = ['/', '/library'];
const INFO_BANNER_ALLOWED_PATH_FRAGMENTS = ['your-learning'];
const INFO_BANNER_DISMISSED_KEY = 'upskill.infoBanner.dismissed';


// Determines whether the info banner should render for the given pathname.
export function isInfoBannerPath(pathname: string): boolean {
  if (INFO_BANNER_ALLOWED_PATHS.includes(pathname as (typeof INFO_BANNER_ALLOWED_PATHS)[number])) {
    return true;
  }

  return INFO_BANNER_ALLOWED_PATH_FRAGMENTS.some((fragment) => pathname.includes(fragment));
}

//Returns the identifier of the banner the user last dismissed, if any.
export function getDismissedBannerId(): string | null {
  try {
    return window.localStorage.getItem(INFO_BANNER_DISMISSED_KEY);
  } catch {
    return null;
  }
}

/**
 * Persists the identifier of the banner the user has dismissed.
 */
export function setDismissedBannerId(bannerId: string): void {
  try {
    window.localStorage.setItem(INFO_BANNER_DISMISSED_KEY, bannerId);
  } catch {
    //something went wrong
    return;
  }
}
